import { theme } from '@cc-shopping/ui/theme';
import type { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';
import type { AlignValue, SpacingValue } from './types';

export const SPACING_PROP_MAPPER: Record<SpacingValue, number> = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  '3-half': 3.5,
  4: 4,
  5: 5,
};

export const CONTAINER_STYLE_MAPPER: Record<AlignValue, SystemStyleObject<Theme>> = {
  none: {
    float: 'none',
  },
  center: {
    float: 'none',
  },
  left: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: '20em',
      marginLeft: 'calc(1.75rem + 0.25 * (100vw - 27.5rem) / 54.5)',
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: '2rem',
    },
  },
  right: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: '20em',
      marginRight: 'calc(1.75rem + 0.25 * (100vw - 27.5rem) / 54.5)',
    },
    [theme.breakpoints.up('md')]: {
      marginRight: '2rem',
    },
  },
};
